/*
 * <variant-media-sync> — reverse gallery↔variant sync.
 *
 * The theme already scrolls the gallery to a variant's featured media when the variant changes.
 * This element adds the opposite direction: when the gallery settles on a media that is the
 * featured media of a variant, it selects that variant (which updates price, buy buttons, the
 * shade list, the tagline... through the standard variant:change flow).
 *
 * It reads a JSON map (mediaId -> [optionValueId, ...]) and, on carousel:settle, checks the
 * matching option radios and dispatches a change so <variant-picker> performs the selection.
 */
(function () {
  if (window.customElements.get('variant-media-sync')) {
    return;
  }

  var VariantMediaSync = class extends HTMLElement {
    connectedCallback() {
      try {
        this._map = JSON.parse(this.querySelector('script[data-media-variant-map]')?.textContent || '{}');
      } catch (error) {
        this._map = {};
      }

      // Option radios live inside <variant-picker> (associated to the form via the form="" attribute),
      // NOT inside the <form> element — so we match them by that attribute across the document.
      this._formId = this.getAttribute('form');
      this._carousel = document.getElementById(this.getAttribute('carousel'));

      if (!this._formId || !this._carousel) {
        return;
      }

      this._onMedia = this.onMedia.bind(this);
      // carousel:change fires immediately when the selected media changes (e.g. thumbnail click),
      // carousel:settle fires once scrolling finishes — listen to both for reliability.
      this._carousel.addEventListener('carousel:change', this._onMedia);
      this._carousel.addEventListener('carousel:settle', this._onMedia);
    }

    disconnectedCallback() {
      if (this._carousel) {
        this._carousel.removeEventListener('carousel:change', this._onMedia);
        this._carousel.removeEventListener('carousel:settle', this._onMedia);
      }
    }

    findInput(optionValueId) {
      return document.querySelector(
        'input[data-option-position][form="' + this._formId + '"][value="' + optionValueId + '"]'
      );
    }

    onMedia(event) {
      var cell = event.detail && event.detail.cell;
      var mediaId = cell && cell.getAttribute('data-media-id');

      if (!mediaId) {
        return;
      }

      var optionValueIds = this._map[mediaId];

      if (!optionValueIds || !optionValueIds.length) {
        return;
      }

      // Already the active combination → nothing to do (also prevents a feedback loop, since
      // selecting a variant scrolls the gallery back to this same media).
      var allChecked = optionValueIds.every(
        function (id) {
          var input = this.findInput(id);
          return input && input.checked;
        }.bind(this)
      );

      if (allChecked) {
        return;
      }

      var lastInput = null;

      optionValueIds.forEach(
        function (id) {
          var input = this.findInput(id);
          if (input) {
            input.checked = true;
            lastInput = input;
          }
        }.bind(this)
      );

      if (lastInput) {
        lastInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  window.customElements.define('variant-media-sync', VariantMediaSync);
})();
